let Summaryall=[
    {"Countryname":" ",
    "OZ":0,
    "ME":1047,
    "NU":838,
    "DI":1076,
    "HR":1001,
    "CO":941,
    "EC":749,
    "OT":0
    }]
export default Summaryall
